import { render, staticRenderFns } from "./ProcessChargesShipments.vue?vue&type=template&id=cbde9524&scoped=true&"
import script from "./ProcessChargesShipments.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesShipments.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesShipments.vue?vue&type=style&index=0&id=cbde9524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbde9524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbde9524')) {
      api.createRecord('cbde9524', component.options)
    } else {
      api.reload('cbde9524', component.options)
    }
    module.hot.accept("./ProcessChargesShipments.vue?vue&type=template&id=cbde9524&scoped=true&", function () {
      api.rerender('cbde9524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/ProcessChargesShipments.vue"
export default component.exports